
export const interactiveFeatures = {
  subtitle: "Engage Your Audience",
  title: "Boost Engagement with Interactive Features",
  description: "Create interactive experiences that keep your audience engaged and build deeper connections.",
  learnMoreLabel: "Click to learn more",
  tryButton: "Try it out",
  features: [
    {
      title: "Interactive Polls",
      description: "Engage your audience with quick polls that gather feedback and opinions on any topic. Polls increase participation and provide valuable insights into your audience's preferences."
    },
    {
      title: "Voting Systems",
      description: "Let your audience vote on content, decisions, or options to increase their involvement. Voting creates a sense of ownership and strengthens community bonds."
    },
    {
      title: "AI-Powered Quizzes",
      description: "Create engaging quizzes that test knowledge, provide personalized results, and offer valuable insights. Our AI helps create questions that resonate with your audience."
    },
    {
      title: "Custom Notifications",
      description: "Send personalized notifications to keep your audience informed about new content, events, or important updates. Keep engagement high with timely reminders."
    },
    {
      title: "Loyalty Rewards",
      description: "Implement a reward system that recognizes and incentivizes loyal followers. Exclusive content, early access, and special offers build strong community bonds."
    },
    {
      title: "Seamless Integrations",
      description: "Connect your existing tools and platforms for a unified experience. Integrations with popular services make managing your community effortless."
    }
  ],
  stats: {
    engagement: {
      title: "Increased Engagement",
      description: "Average increase in audience participation"
    },
    interaction: {
      title: "Daily Interactions",
      description: "Average interactions per active user"
    },
    retention: {
      title: "Improved Retention",
      description: "Increase in audience retention rate"
    }
  }
};
